import { useState,useEffect } from 'react'


export function TimeBox({ className, level = 1, ...props }) {
    const [hours, setHours] = useState(null);
    const [minutes, setMinutes] = useState(null);
  useEffect(() => {
      if(props.defaultValue) {
            setHours(props.defaultValue.hours);
            setMinutes(props.defaultValue.minutes);
        }
    return () => {

    };
  }, [props.defaultValue]);
    
    
    const onChange=(event) => {
        if(props.changeEvent) {
            let name = event.currentTarget.name;
            let value = event.currentTarget.value;
            props.changeEvent(name, value);
        }
    }    
  return (
    <div className="justify-center flex mt-6 h-16">
        <input defaultValue={hours} type="text" name="hours" className="h-16 w-16 text-center text-5xl" placeholder="00" maxLength={2} onChange={(event) => onChange(event)}/>
        <span className=" w-8 text-center text-5xl text-gray-400 align-middle mt-1">:</span>
        <input  defaultValue={minutes} type="text" name="minutes" className="h-16 w-16 text-center text-5xl" maxLength={2} placeholder="00" onChange={(event) => onChange(event)}/>
    </div>
    )    
}
